import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';
import Radio from 'backbone.radio';

const globalChannel = Radio.channel( 'global' );

class LoadMoreView extends View {
	get template() {
		return template;
	}

	ui() {
		return {
			load_more: '.js-load-more'
		};
	}

	events() {
		return {
			'click.ui.load_more': 'showMore'
		};
	}

	initialize() {
		this.initRadioListeners();
	}

	initRadioListeners() {
		this.listenTo( globalChannel, 'is:show:load:more', is_load_more => {
			this.isHideButton( is_load_more );
		} );

		return this;
	}

	showMore() {
		globalChannel.trigger( 'click:load:more' );
	}

	isHideButton( is_load_more ) {
		let load_more = this.getUI( 'load_more' );
		load_more.toggleClass('hidden', !is_load_more);

		return this;
	}
}

export default LoadMoreView;